import TeamStatistics from 'components/sports/pdl/views/TeamStatistics'
import Accordion from 'react-bootstrap/Accordion';
import Label from "components/general/Label";



function PdlTeamStats({ data }) {

  const stats = [
    { code: 'POINTS' },
    { code: 'BREAK_PTS', component: 'type2' },
    { code: 'RECEIVE', component: 'type2' },
    { code: '2ND_SERVE', header: '2ND_SERVE-POINTS', component: 'type3', paint: 'POINTS_WON' },
    { code: '2ND_SERVE', component: 'type2' },
    { code: '1ST_SERVE', header: '1ST_SERVE-POINTS', component: 'type3', paint: 'POINTS_WON' },
    { code: '1ST_SERVE', component: 'type2' }
  ]

  return (<>
    <Accordion defaultActiveKey={'1'}>
      <Accordion.Item id={`mirs-accordion-item-1`} eventKey={'1'} key={'1'}>
        <Accordion.Header><Label data={'HeaderTotal'} /></Accordion.Header>
        <Accordion.Body>
          <TeamStatistics data={data?.results} stats={stats} period={'TOT'} />
        </Accordion.Body>
      </Accordion.Item>

      {(data?.results?.periods?.find(i => i.p_code === 'S3'))
        ? <><Accordion.Item id={`mirs-accordion-item-1`} eventKey={'2'} key={'2'}>
          <Accordion.Header><Label data={'Header3rdSet'} /></Accordion.Header>
          <Accordion.Body>
            <TeamStatistics data={data?.results} stats={stats} period={'S3'} />
          </Accordion.Body>
        </Accordion.Item>
        </>
        : ''
      }

      {(data?.results?.periods?.find(i => i.p_code === 'S2'))
        ? <><Accordion.Item id={`mirs-accordion-item-2`} eventKey={'3'} key={'3'}>
          <Accordion.Header><Label data={'Header2ndSet'} /></Accordion.Header>
          <Accordion.Body>
            <TeamStatistics data={data?.results} stats={stats} period={'S2'} />
          </Accordion.Body>
        </Accordion.Item>
        </>
        : ''
      }

      {(data?.results?.periods?.find(i => i.p_code === 'S1'))
        ? <><Accordion.Item id={`mirs-accordion-item-3`} eventKey={'4'} key={'4'}>
          <Accordion.Header><Label data={'Header1stSet'} /></Accordion.Header>
          <Accordion.Body>
            <TeamStatistics data={data?.results} stats={stats} period={'S1'} />
          </Accordion.Body>
        </Accordion.Item>
        </>
        : ''
      }

    </Accordion><br />
  </>);
}



export default PdlTeamStats;